module.exports = __webpack_public_path__ + "img/signage_control_on.b17a5510.png";